"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ubiScoreFeedSchema = exports.insurerPartnerSchema = exports.insurerWebhookSchema = exports.insurerWebhookEventSchema = exports.ubiDriverRecordFeedSchema = exports.ubiDriverActionResultSchema = exports.executeUbiDriverActionSchema = exports.createUbiDriverCommentSchema = exports.ubiDriverRecordSchema = exports.ubiDriverRecordSummarySchema = exports.ubiLeaderboardPageSchema = exports.ubiLeaderboardQuerySchema = exports.ubiLeaderboardSortBySchema = exports.ubiLeaderboardEntrySchema = exports.ubiDriverFeedbackItemSchema = exports.ubiDriverFeedbackKindSchema = exports.ubiDriverTriggerLogSchema = exports.ubiDriverTripSummarySchema = exports.ubiDriverEventCountsSchema = exports.ubiDriverComponentBreakdownSchema = exports.ubiDriverPolicySummarySchema = exports.ubiDriverVehicleSummarySchema = exports.ubiDriverActionTypeSchema = exports.ubiDriverRewardSchema = exports.ubiDriverTierSchema = exports.ubiRiskBandSchema = exports.ubiPolicySchema = exports.ubiPolicyMetadataSchema = exports.ubiPolicyCoverageTierSchema = exports.ubiPolicyStatusSchema = exports.ubiConsentRecordSchema = exports.ubiConsentStatusSchema = exports.ubiTelemetrySummarySchema = exports.ubiRiskScoreSchema = exports.ubiRiskFactorSchema = void 0;
const zod_1 = require("zod");
const drivers_1 = require("./drivers");
const tickets_1 = require("./tickets");
exports.ubiRiskFactorSchema = zod_1.z.object({
    name: zod_1.z.string(),
    value: zod_1.z.number(),
    impact: zod_1.z.number(),
});
exports.ubiRiskScoreSchema = zod_1.z.object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    driverId: zod_1.z.string(),
    vehicleId: zod_1.z.string().nullable(),
    window: zod_1.z.enum(["7d", "28d", "90d"]),
    riskIndex: zod_1.z.number().min(0).max(100),
    confidence: zod_1.z.number().min(0).max(1),
    factors: zod_1.z.array(exports.ubiRiskFactorSchema),
    exposureKm: zod_1.z.number().nonnegative(),
    exposureHours: zod_1.z.number().nonnegative(),
    eventsPer100Km: zod_1.z.number().nonnegative(),
    createdAt: zod_1.z.string(),
});
exports.ubiTelemetrySummarySchema = zod_1.z.object({
    tenantId: zod_1.z.string(),
    driverId: zod_1.z.string(),
    vehicleId: zod_1.z.string().nullable(),
    from: zod_1.z.string(),
    to: zod_1.z.string(),
    km: zod_1.z.number().nonnegative(),
    hours: zod_1.z.number().nonnegative(),
    ha: zod_1.z.number().int().nonnegative(),
    hb: zod_1.z.number().int().nonnegative(),
    hc: zod_1.z.number().int().nonnegative(),
    overspeedSeconds: zod_1.z.number().nonnegative(),
    idleSeconds: zod_1.z.number().nonnegative(),
    impactCount: zod_1.z.number().int().nonnegative(),
    nightKmPct: zod_1.z.number().min(0).max(100).nullable().optional(),
    rainHours: zod_1.z.number().nonnegative().nullable().optional(),
});
exports.ubiConsentStatusSchema = zod_1.z.enum(["pending", "granted", "revoked"]);
exports.ubiConsentRecordSchema = zod_1.z.object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    driverId: zod_1.z.string(),
    policyVersion: zod_1.z.string(),
    status: exports.ubiConsentStatusSchema,
    grantedAt: zod_1.z.string().nullable(),
    revokedAt: zod_1.z.string().nullable(),
    locale: zod_1.z.string().default("en"),
    channel: zod_1.z.enum(["web", "mobile", "api"]),
});
exports.ubiPolicyStatusSchema = zod_1.z.enum(["quote", "bound", "active", "suspended", "cancelled"]);
exports.ubiPolicyCoverageTierSchema = zod_1.z.enum([
    "basic",
    "standard",
    "plus",
    "enterprise",
    "premium",
    "ultra",
]);
exports.ubiPolicyMetadataSchema = zod_1.z
    .object({
    policyNumber: zod_1.z.string().min(1).optional().nullable(),
    brokerReference: zod_1.z.string().optional().nullable(),
    coverageTier: exports.ubiPolicyCoverageTierSchema.optional(),
    termMonths: zod_1.z.number().int().positive().max(120).optional().nullable(),
    deductible: zod_1.z.number().nonnegative().optional().nullable(),
    coverageLimits: zod_1.z
        .object({
        thirdParty: zod_1.z.number().nonnegative().optional().nullable(),
        comprehensive: zod_1.z.number().nonnegative().optional().nullable(),
        mileageCapKm: zod_1.z.number().nonnegative().optional().nullable(),
    })
        .partial()
        .optional(),
    addOns: zod_1.z
        .object({
        roadsideAssistance: zod_1.z.boolean().optional().nullable(),
        accidentalDamageCoverage: zod_1.z.boolean().optional().nullable(),
        breakdownCoverage: zod_1.z.boolean().optional().nullable(),
    })
        .partial()
        .optional(),
    insurerProfile: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
    notes: zod_1.z.string().trim().optional().nullable(),
})
    .passthrough();
exports.ubiPolicySchema = zod_1.z.object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    insurerId: zod_1.z.string(),
    driverId: zod_1.z.string(),
    vehicleId: zod_1.z.string(),
    program: zod_1.z.enum(["PAYD", "PHYD", "HYBRID"]),
    basePremium: zod_1.z.number().nonnegative(),
    currentPremium: zod_1.z.number().nonnegative(),
    currency: zod_1.z.string().min(3).max(3),
    status: exports.ubiPolicyStatusSchema,
    effectiveDate: zod_1.z.string(),
    expirationDate: zod_1.z.string().nullable(),
    metadata: exports.ubiPolicyMetadataSchema.optional(),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.ubiRiskBandSchema = zod_1.z.enum(["low", "medium", "high", "critical"]);
exports.ubiDriverTierSchema = zod_1.z.enum([
    "Platinum",
    "Gold",
    "Silver",
    "Bronze",
]);
exports.ubiDriverRewardSchema = zod_1.z.enum([
    "Gold",
    "Silver",
    "Bronze",
    "None",
]);
exports.ubiDriverActionTypeSchema = zod_1.z.enum([
    "message",
    "coaching",
    "incentive",
    "score-adjustment",
    "reset-events",
]);
exports.ubiDriverVehicleSummarySchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    label: zod_1.z.string(),
    regNo: zod_1.z.string().nullable().optional(),
    makeModel: zod_1.z.string().nullable().optional(),
    assetType: zod_1.z.string().nullable().optional(),
})
    .strict();
exports.ubiDriverPolicySummarySchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    insurerId: zod_1.z.string(),
    insurerName: zod_1.z.string().nullable(),
    vehicleId: zod_1.z.string(),
    program: exports.ubiPolicySchema.shape.program,
    status: exports.ubiPolicyStatusSchema,
    currentPremium: zod_1.z.number().nonnegative(),
    basePremium: zod_1.z.number().nonnegative(),
    currency: zod_1.z.string().min(3).max(3),
    discountPct: zod_1.z.number().nullable(),
    effectiveDate: zod_1.z.string(),
    expirationDate: zod_1.z.string().nullable(),
    policyNumber: zod_1.z.string().nullable().optional(),
})
    .strict();
exports.ubiDriverComponentBreakdownSchema = zod_1.z
    .object({
    braking: zod_1.z.number().min(0).max(100),
    acceleration: zod_1.z.number().min(0).max(100),
    cornering: zod_1.z.number().min(0).max(100),
    speedLimit: zod_1.z.number().min(0).max(100),
    smoothness: zod_1.z.number().min(0).max(100),
})
    .strict();
exports.ubiDriverEventCountsSchema = zod_1.z
    .object({
    harshBraking: zod_1.z.number().int().nonnegative(),
    rapidAccel: zod_1.z.number().int().nonnegative(),
    harshCorner: zod_1.z.number().int().nonnegative(),
    speedingEvents: zod_1.z.number().int().nonnegative(),
    phoneDistraction: zod_1.z.number().int().nonnegative(),
})
    .strict();
exports.ubiDriverTripSummarySchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    vehicleId: zod_1.z.string(),
    vehicleLabel: zod_1.z.string(),
    startTime: zod_1.z.string(),
    endTime: zod_1.z.string(),
    durationSeconds: zod_1.z.number().int().nonnegative(),
    distanceKm: zod_1.z.number().nonnegative(),
    score: zod_1.z.number().min(0).max(100),
    triggerCount: zod_1.z.number().int().nonnegative(),
    alertCount: zod_1.z.number().int().nonnegative(),
    eventSummary: zod_1.z.string(),
})
    .strict();
exports.ubiDriverTriggerLogSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    tripId: zod_1.z.string().nullable(),
    vehicleId: zod_1.z.string().nullable(),
    type: zod_1.z.string(),
    description: zod_1.z.string(),
    severity: zod_1.z.string(),
    source: zod_1.z.string(),
    recordedAt: zod_1.z.string(),
    lat: zod_1.z.number().nullable().optional(),
    lng: zod_1.z.number().nullable().optional(),
})
    .strict();
exports.ubiDriverFeedbackKindSchema = zod_1.z.enum([
    "comment",
    "action",
    "system",
]);
exports.ubiDriverFeedbackItemSchema = zod_1.z
    .object({
    id: zod_1.z.string(),
    ticketId: zod_1.z.string().nullable(),
    kind: exports.ubiDriverFeedbackKindSchema,
    action: exports.ubiDriverActionTypeSchema.nullable().optional(),
    actorType: zod_1.z.enum(["SYSTEM", "USER", "SERVICE"]),
    authorId: zod_1.z.string().nullable(),
    authorName: zod_1.z.string(),
    message: zod_1.z.string(),
    createdAt: zod_1.z.string(),
    attachments: zod_1.z.array(tickets_1.ticketAttachmentSchema).default([]),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
})
    .strict();
exports.ubiLeaderboardEntrySchema = zod_1.z
    .object({
    driverId: zod_1.z.string(),
    driverName: zod_1.z.string(),
    driverInitials: zod_1.z.string(),
    vehicleId: zod_1.z.string().nullable(),
    vehicleLabel: zod_1.z.string().nullable(),
    score: zod_1.z.number().min(0).max(100),
    confidence: zod_1.z.number().min(0).max(1).nullable(),
    rank: zod_1.z.number().int().positive(),
    trips: zod_1.z.number().int().nonnegative(),
    improvementPct: zod_1.z.number(),
    reward: exports.ubiDriverRewardSchema,
    tier: exports.ubiDriverTierSchema,
    premiumDiscountPct: zod_1.z.number().nullable(),
    lastAssessmentAt: zod_1.z.string().nullable(),
    riskBand: exports.ubiRiskBandSchema,
})
    .strict();
exports.ubiLeaderboardSortBySchema = zod_1.z.enum([
    "score",
    "name",
    "trend",
]);
exports.ubiLeaderboardQuerySchema = zod_1.z
    .object({
    search: zod_1.z.string().trim().optional(),
    riskBand: exports.ubiRiskBandSchema.optional(),
    minScore: zod_1.z.number().min(0).max(100).default(0),
    maxScore: zod_1.z.number().min(0).max(100).default(100),
    sortBy: exports.ubiLeaderboardSortBySchema.default("score"),
    sortOrder: zod_1.z.enum(["asc", "desc"]).default("desc"),
    page: zod_1.z.number().int().positive().default(1),
    pageSize: zod_1.z.number().int().positive().max(100).default(5),
})
    .strict();
exports.ubiLeaderboardPageSchema = zod_1.z
    .object({
    items: zod_1.z.array(exports.ubiLeaderboardEntrySchema),
    pageInfo: zod_1.z
        .object({
        page: zod_1.z.number().int().positive(),
        pageSize: zod_1.z.number().int().positive(),
        totalItems: zod_1.z.number().int().nonnegative(),
        totalPages: zod_1.z.number().int().nonnegative(),
    })
        .strict(),
})
    .strict();
exports.ubiDriverRecordSummarySchema = zod_1.z
    .object({
    totalKm: zod_1.z.number().nonnegative(),
    totalHours: zod_1.z.number().nonnegative(),
    totalTrips: zod_1.z.number().int().nonnegative(),
    lastAssessmentAt: zod_1.z.string().nullable(),
    coachingStatus: zod_1.z.string(),
    premiumDiscountPct: zod_1.z.number().nullable(),
    riskBand: exports.ubiRiskBandSchema,
    score: zod_1.z.number().min(0).max(100),
    confidence: zod_1.z.number().min(0).max(1).nullable(),
})
    .strict();
exports.ubiDriverRecordSchema = zod_1.z
    .object({
    driver: drivers_1.driverSchema,
    leaderboard: exports.ubiLeaderboardEntrySchema,
    vehicle: exports.ubiDriverVehicleSummarySchema.nullable(),
    vehicles: zod_1.z.array(exports.ubiDriverVehicleSummarySchema),
    policy: exports.ubiDriverPolicySummarySchema.nullable(),
    policies: zod_1.z.array(exports.ubiDriverPolicySummarySchema),
    summary: exports.ubiDriverRecordSummarySchema,
    scoreFactors: zod_1.z.array(exports.ubiRiskFactorSchema),
    componentBreakdown: exports.ubiDriverComponentBreakdownSchema,
    eventCounts: exports.ubiDriverEventCountsSchema,
    recentTrips: zod_1.z.array(exports.ubiDriverTripSummarySchema),
    triggerLogs: zod_1.z.array(exports.ubiDriverTriggerLogSchema),
    feedback: zod_1.z.array(exports.ubiDriverFeedbackItemSchema),
    generatedAt: zod_1.z.string(),
})
    .strict();
exports.createUbiDriverCommentSchema = zod_1.z
    .object({
    body: zod_1.z.string().trim().min(1).max(2000),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
})
    .strict();
exports.executeUbiDriverActionSchema = zod_1.z
    .object({
    action: exports.ubiDriverActionTypeSchema,
    note: zod_1.z.string().trim().max(2000).optional().nullable(),
    delta: zod_1.z.number().min(-20).max(20).optional().nullable(),
    metadata: zod_1.z.record(zod_1.z.string(), zod_1.z.unknown()).optional(),
})
    .strict();
exports.ubiDriverActionResultSchema = zod_1.z
    .object({
    feedback: exports.ubiDriverFeedbackItemSchema,
    record: exports.ubiDriverRecordSchema,
})
    .strict();
exports.ubiDriverRecordFeedSchema = zod_1.z
    .object({
    data: zod_1.z.array(exports.ubiDriverRecordSchema),
    nextCursor: zod_1.z.string().nullable().optional(),
    generatedAt: zod_1.z.string(),
})
    .strict();
exports.insurerWebhookEventSchema = zod_1.z.enum([
    "ins.quote.created",
    "ins.policy.bound",
    "ins.score.updated",
    "ins.adjustment.posted",
    "ins.driver.comment.created",
    "ins.driver.record.updated",
]);
exports.insurerWebhookSchema = zod_1.z.object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    url: zod_1.z.string(),
    secret: zod_1.z.string(),
    eventTypes: zod_1.z.array(exports.insurerWebhookEventSchema),
    createdAt: zod_1.z.string(),
});
exports.insurerPartnerSchema = zod_1.z.object({
    id: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    name: zod_1.z.string(),
    baseUrl: zod_1.z.string(),
    authMode: zod_1.z.enum(["mtls", "oauth"]),
    certId: zod_1.z.string().nullable(),
    clientId: zod_1.z.string().nullable(),
    clientSecret: zod_1.z.string().nullable(),
    scopes: zod_1.z.array(zod_1.z.string()).default([]),
    territories: zod_1.z.array(zod_1.z.string()).default([]),
    features: zod_1.z.array(zod_1.z.string()).default([]),
    status: zod_1.z.enum(["sandbox", "live", "disabled"]).default("sandbox"),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.ubiScoreFeedSchema = zod_1.z.object({
    ts: zod_1.z.string(),
    tenantId: zod_1.z.string(),
    driverId: zod_1.z.string(),
    window: zod_1.z.enum(["7d", "28d", "90d"]),
    riskIndex: zod_1.z.number().min(0).max(100),
    confidence: zod_1.z.number().min(0).max(1),
    factors: zod_1.z.array(exports.ubiRiskFactorSchema),
});
